import request from "@/utils/request";
export function apply (data) {
    return request({
        url: '/admin/app/yykfTJ',
        method: 'post',
        data
    })
}
